import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CellEditingStoppedEvent, ICellRendererParams, ColDef, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { ObjectUnsubscribedError, Observable, catchError, filter, map, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-inventory-warehouses',
  templateUrl: './inventory-warehouses.component.html',
  styleUrls: ['./inventory-warehouses.component.scss']
})
export class InventoryWarehousesComponent {

  public gridReady = false;

  private gridApi!: GridApi;
  warehouses!: any[]

  public themeClass: string ="ag-theme-ulaap";

  constructor(private http: HttpClient, private dialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
    const url = "/api/inventory/inventory_warehouses.php"
    this.http.get(url).subscribe((response: any) => {
      if (response) {
        console.log(response.data);
        this.warehouses = response.data;
      }
      this.gridReady = true;
    })
    // console.log('this is the hello world', this.contact_names);
    // this.getTest("90a8a818-1107-4f16-9609-b0c7d06d9eac");
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true,
  };

  public columnDefs: ColDef[] = [
    { field: 'inventory_warehouse_uuid', headerName: 'Inventory Warehouse UUID' },
    { field: 'inventory_warehouse_name', headerName: 'Inventory Warehouse Name' },
    { field: 'highest_level', headerName: 'Highest Level'},
    { field: 'highest_row', headerName: 'Highest Row'},
    { field: 'highest_section', headerName: 'Highest Section'},
    { field: 'highest_spot', headerName: 'Highest Spot'},
    { field: 'total', headerName: 'Total'},
    { field: 'occupied', headerName: 'Occupied' },
    { field: 'Action', 
      cellRenderer: ViewInventoryManagerComponent,
      // cellRendererParams: {
      //   onClick: this.navigateToInventoryManagement.bind(this)
      // }
  }
  ]

  navigateToInventoryManagement(params: any) {
    // Extract the UUID from the row data
    const uuid = params.data.inventory_warehouse_uuid;
    console.log('uuid', uuid)
    // Navigate to the '/inventory_management/:uuid' route
    this.router.navigate(['/inventory_management', uuid]);
  }

}

@Component({
  selector: 'app-cell-renderer',
  template: `
    <span matTooltip="View Warehouse Details">
      <a [attr.href]="getWarehouseDetailsLink()">
        <i class="fa-solid fa-eye"></i>
      </a>
    </span>
  `,
})
export class ViewInventoryManagerComponent {

  params: any;

  constructor(private router: Router) { }

  getWarehouseDetailsLink(): string {
    return `/inventory_management/${this.params.data.inventory_warehouse_uuid}`;
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

}
